import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router';
import { useSelector } from 'react-redux';

// Constants
import { InputSources } from '../InputSources.constants';

// Hooks
import { useToggle, useQueryParam } from 'Shared/utils/hooks';
import { useUpdateAiSetting } from 'Shared/utils/hooks/use-update-ai-setting';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Types
import { IntegrationSources } from '../types';

// Components
import SourceWrapper from './SourceWrapper';
import SalesforceSourceModal from './SalesforceSourceModal';

const SalesforceSource = () => {
  const { slug } = useParams();
  const history = useHistory();

  const [isOpen, toggleIsOepn] = useToggle(false);
  const [postOauthConnected] = useQueryParam('connected');

  const { salesforceSourceConfiguration, handleUpdateAiSetting } = useUpdateAiSetting({ slug });

  const srcId = IntegrationSources.SALEFORCE;

  const source = InputSources.find(src => src.id === srcId);
  const isSelected = Boolean(salesforceSourceConfiguration);

  const oauthRedirectUrl = PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug }) + `?connected=${srcId}`;

  const connected = useSelector(state => state.organization.hasSalesforceIntegration);

  const handleUpdate = () => {
    if (!isSelected) handleUpdateAiSetting({ dataSources: { [srcId]: {} } });
  };

  const handleClick = () => {
    if (!connected) toggleIsOepn();
    else handleUpdate();
  };

  useEffect(() => {
    if (postOauthConnected && postOauthConnected === srcId) {
      history.push(PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug }));
      handleUpdate();
    }
  }, []);

  return (
    <>
      <SourceWrapper
        logo={source.logo}
        name={source.name}
        selected={isSelected}
        onClick={handleClick}
        connected={connected}
      />
      <SalesforceSourceModal isOpen={isOpen} toggleIsOpen={toggleIsOepn} oauthRedirectUrl={oauthRedirectUrl} />
    </>
  );
};

export default SalesforceSource;
